<template>
  <div>
    <v-container style="max-width: 1000px;">
      <v-row>
        <v-col cols="12" sm="6">
          <h1>Hi {{ $route.query.customerFirstName }},</h1>

          <h3 class="mt-2 primary--text"><strong>The results of your Bicycle Certification Test are in!</strong></h3>

          <p class="mt-4">
            Our technician has carried out the 104-point Bicycle Certification Test for safety and roadworthiness of your bike and has found some additional work that should be completed as part of the service.
          </p>

          <h2 class="primary--text">
            What happens next?
          </h2>
          <ul class="mt-4">
            <li>After clicking the button below, please complete the form</li>
            <li class="mt-2">Remember to tell us which work you are approving</li>
            <li class="mt-2">We will confirm all of the approved work via email</li>
          </ul>

          <v-btn color="green" dark x-large class="mt-6 mb-6" @click="openBeacon('f359d789-bb17-4040-bb97-10eedaa368f8')">
            Get Started!
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <img style="width: 100%;" src="https://havebike-cdn.s3.eu-west-2.amazonaws.com/assets/150413_HB_Servicing_1043.jpg" alt="">
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import HasBeacon from '@/mixins/HasBeacon'

export default {
  name: 'ApprovePage',

  mixins: [ HasBeacon ],

  data () {
    return {

    }
  },

  mounted () {
    window.Beacon('prefill', {
      name: this.$route.query.customerName,
      email: this.$route.query.customerEmail,
      subject: this.$route.query.beaconSubject,
      text: this.$route.query.beaconText,
      fields: [
        {
          id: 30195,
          value: 155561
        },
        {
          id: 30157,
          value: this.$route.query.jobNumber
        },
        {
          id: 30196,
          value: 166116
        }
      ],
    })

    window.Beacon('config', {
      showPrefilledCustomFields: true,
      labels: {
        sendAMessage: 'My bike is in the workshop',
        wereHereToHelp: 'Approve additional spend',
        howCanWeHelp: 'Approve additional spend',
        responseTime: 'If you have questions, we will get back to you',
        messageSubmitLabel: 'Send Approval',
        messageConfirmationText: 'You will soon receive confirmation of the approved spend. If you had any questions, we will get back to you as soon as we can!',
        messageLabel: 'What work would you like to approve?'
      },
    })
  }
} 
</script>

<style lang="css" scoped>
</style>